import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
// Styles
import useStyles from "assets/jss/material-react/views/italmundoStyles";
import { useTheme } from "@mui/material/styles";
// Components
import { Box, Button, useMediaQuery, TextField } from "@mui/material";
import PageContainer from "../../components/PageContainer/PageContainer";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import ReCAPTCHA from "react-google-recaptcha";
import { SinProductos } from "../../components/Modals";
// Assets
import {
  IconoMensajeErrorItal,
  Reloj,
  HomeDesktopImage,
  HomeMobileImage,
} from "assets";
// Services
import ClientService from "services/clientService";
import { saveSessionDocument } from "services/sessionStorageService";
import { getProductNameById, URLs } from "utils/redirectStep";

const nroTelefono = window.nroTelefono;
const captchaKey = window.captchaKey;
function Home() {
  //Inicializaciones base
  const clientService = new ClientService();
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();

  const mobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [loading, setLoading] = React.useState(false);

  const [modal, setModal] = React.useState({
    open: false,
    title: "",
    message: "",
    content: null,
  });

  // Inicializaciones particulares
  const [user, setUser] = React.useState({
    document: "",
  });
  const [error, setError] = React.useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const utmClient = searchParams.get("utm_source");
  const utmCampaign = searchParams.get("utm_campaign");
  const utmContent = searchParams.get("utm_content");
  const [captchaVerified, setCaptchaVerified] = React.useState(false);

  const buildNavigateUrl = (path) => {
    const params = new URLSearchParams(searchParams);
    return `${path}?${params.toString()}`;
  };

  const handleSolicitarAhoraClick = async () => {
    if (!user.document) {
      setError("Este campo es requerido.");
      return;
    }

    if (user.document.length < 7) {
      setError("La cédula debe tener un mínimo de 7 caracteres.");
      return;
    }

    const documento = parseInt(user.document, 10);
    setLoading(true);
    const response = await clientService.evaluateDocument(documento);
    saveSessionDocument(documento);
    let code = response.code;
    setLoading(false);

    switch (code) {
      case 0: {
        let codigoEstado = response.data.codigoEstado;
        const transaction = {
          ...response.data,
          utmClient,
          utmCampaign,
          utmContent,
        };
        const responseEstado = await clientService.getInfoEstado(transaction);
        if (responseEstado.code === 500) {
          navigate(buildNavigateUrl(URLs.errorInesperado));
          return;
        }
        switch (codigoEstado) {
          case 200:
            navigate(buildNavigateUrl(URLs.enProcesoAprobacion));
            break;
          case 300:
            navigate(buildNavigateUrl(URLs.esCliente));
            break;
          case 99:
            navigate(buildNavigateUrl(URLs.noCalifica));
            break;
          case 14:
            navigate(
              buildNavigateUrl(URLs.pagoPendiente, {
                state: { messagePending: response.message },
              }),
            );
            break;
          case 0:
            navigate(buildNavigateUrl(`${URLs.datosPersonales}`), {
              state: { transaction: { ...transaction, codigoPaso: 1 } },
            });
            break;
          case 1:
            navigate(buildNavigateUrl(`${URLs.datosPersonales}`), {
              state: { transaction: { ...transaction, codigoPaso: 1 } },
            });
            break;
          case 2:
            navigate(buildNavigateUrl(URLs.solicitudEnCurso), {
              state: {
                destinationUrl: buildNavigateUrl(URLs.datosLaborales),
                destinationState: { transaction: { ...transaction, codigoPaso: 2 } },
              },
            });
            break;
          case 3: {
            const newTransaction = {
              ...transaction,
              tipoDeEmpleoElegido: responseEstado.data.infoDocumentacion,
              codigoPaso: 3,
            };
            const nombreProducto3 = getProductNameById(responseEstado.data.productId);
            if (nombreProducto3) {
              navigate(buildNavigateUrl(URLs.solicitudEnCurso), {
                state: {
                  destinationUrl: buildNavigateUrl(`${URLs.oferta}/${nombreProducto3}`),
                  destinationState: { transaction: newTransaction, userData: responseEstado.data },
                },
              });
            }
            break;
          }
          case 4: {
            const newTransaction = {
              ...transaction,
              productName: responseEstado.data.productName,
              tipoDeEmpleoElegido: responseEstado.data.infoDocumentacion,
              codigoPaso: 4,
            };
            const destinationUrl4 =
              responseEstado.data.requiereDoc === false
                ? buildNavigateUrl(URLs.agenciaDeRetiro)
                : buildNavigateUrl(
                    `${URLs.solicitarMiTarjeta}/${responseEstado.data.productName}`,
                  );
            navigate(buildNavigateUrl(URLs.solicitudEnCurso), {
              state: {
                destinationUrl: destinationUrl4,
                destinationState: { transaction: newTransaction },
              },
            });
            break;
          }
          case 5: {
            const newTransaction = {
              ...transaction,
              productName: responseEstado.data.productName,
              codigoPaso: 5,
            };
            navigate(buildNavigateUrl(URLs.solicitudEnCurso), {
              state: {
                destinationUrl: buildNavigateUrl(URLs.verificacionCelular),
                destinationState: { transaction: newTransaction },
              },
            });
            break;
          }
          case 6: {
            const newTransaction = {
              ...transaction,
              productName: responseEstado.data.productName,
              pagoAnticipado:
                responseEstado.data.ofertaConfirmada.pagoAnticipado,
            };
            navigate(buildNavigateUrl(URLs.solicitudEnCurso), {
              state: {
                destinationUrl: buildNavigateUrl(URLs.costoDeActivacion),
                destinationState: { transaction: newTransaction },
              },
            });
            break;
          }
          default:
            navigate(buildNavigateUrl(URLs.errorInesperado));
        }
        break;
      }
      case 400:
        openModalDocumentoInvalido();
        return;
      case 401:
        setModal({
          open: true,
          showX: true,
          message: "Ha realizado demasiadas consultas. Intente más tarde.",
        });
        return;
      default:
        navigate(buildNavigateUrl(URLs.intenteLuego));
        return;
    }
  };

  const openModalDocumentoInvalido = () => {
    setModal({
      open: true,
      showX: true,
      content: (
        <Box className={classes.modalContentDynamic}>
          <p className={classes.modalMessage}>
            El documento es inválido, verificá el número ingresado.
          </p>
          <Button
            className={`${classes.btnFull} ${classes.btnAzul}`}
            variant="text"
            onClick={handleModalCloseClick}
            sx={{
              marginTop: "1.5rem",
              width: "100px",
            }}
          >
            {"OK"}
          </Button>
        </Box>
      ),
    });
  };

  function handleModalCloseClick() {
    setModal({ ...modal, open: false });
  }

  function onChange(value) {
    setCaptchaVerified(!!value);
  }

  return (
    <PageContainer
      loading={loading}
      modal={modal}
      handleModalCloseClick={handleModalCloseClick}
      canonicalUrl={URLs.home}
      noImage={true}
    >
      {mobile ? (
        <div
          className={classes.contentImageMobileHome}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <img
            src={HomeMobileImage}
            alt="Home Mobile"
            style={{
              width: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        </div>
      ) : (
        <div
          className={classes.contentImageDesktop}
          // style={{
          //   display: "flex",
          //   flexDirection: "column",
          //   justifyContent: "end",
          //   alignItems: "center",
          // }}
        >
          <img
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
            }}
            src={HomeDesktopImage}
          />
        </div>
      )}
      <ProgressBar currentStep={"PASO 1"} sx={{ marginTop: "1rem" }} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "1rem",
          width: "100%",
          maxWidth: "380px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "1rem",
            width: "100%",
          }}
        >
          <img
            src={Reloj}
            alt="Reloj"
            style={{
              marginRight: "8px",
              width: "24px",
              height: "24px",
            }}
          />
          <p
            style={{
              fontSize: "14px",
              fontWeight: "520",
            }}
          >
            Sólo te va a llevar <span className="special-font">5</span> minutos
          </p>
        </Box>
        <TextField
          id="filled-required"
          label="Ingresá tu cédula con dígito verificador*"
          variant="filled"
          type="text"
          error={error !== ""}
          placeholder="99999999"
          onInput={(e) => {
            let newLetter = e.target.value.substring(e.target.value.length - 1);
            if (isNaN(newLetter)) {
              let newValue = e.target.value.slice(0, -1);
              e.target.value = newValue;
              setUser({ document: newValue });
            } else {
              e.target.value = e.target.value.slice(0, 8);
              setUser({ document: e.target.value.slice(0, 8) });
            }
          }}
          helperText={error}
          className={classes.inputCustom}
          sx={{
            marginTop: "1rem",
            width: "90%",
            maxWidth: "380px",
          }}
        />
        <Box
          sx={{
            marginTop: "1rem",
            width: "90%",
            maxWidth: "380px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <ReCAPTCHA
            className={classes.captchaContainer}
            sitekey={captchaKey}
            onChange={onChange}
          />
        </Box>
        <p
          style={{
            fontSize: "9px",
            lineHeight: "1.2",
            marginTop: "1.3rem",
            width: "80%",
            maxWidth: "320px",
            textAlign: "center",
          }}
        >
          <span className="special-font">*</span> Usted está solicitando ser
          contactado por un asesor para informarle sobre los servicios ofrecidos
          por Verendy S.A.
        </p>
        <div className={classes.divBtn}>
          <Button
            className={`${classes.btnFull} ${classes.btnAzul}`}
            variant="text"
            disabled={loading || !captchaVerified}
            onClick={handleSolicitarAhoraClick}
            sx={{
              marginTop: "1rem",
              width: "100%",
            }}
          >
            {"SOLICITAR AHORA"}
          </Button>
        </div>
      </Box>
    </PageContainer>
  );
}

export default Home;
